// extracted by mini-css-extract-plugin
export default {"checkboxesContainer":"BannerForm_checkboxesContainer__0IkhJ","formRow":"BannerForm_formRow__BHwVp"};